import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Dots: FunctionalComponent = () => {
  return (
    <span class={styles.root}>
      <span class={styles.dot} />
      <span class={styles.dot} />
      <span class={styles.dot} />
    </span>
  )
}
